import React, { useState } from "react";
import { MdOutlineGridView, MdMap, MdList } from "react-icons/md";
import AreaQualifierAreaList from './area-qualifier-area-list';
import AreaQualifierAreaCards from './area-qualifier-area-cards';
export const VIEW_MODES = {
  GRID: 'grid',
  LIST: 'list'
};
const AreaQualifierRegionView = ({
  areas
}) => {
  const [viewMode, setViewMode] = useState(VIEW_MODES.LIST);
  const baseListClass = `hover:text-accent ml-3`;
  const generateViewClasses = mode => mode === viewMode ? `${baseListClass} text-accent` : `${baseListClass}`;
  const renderRegionView = mode => {
    switch (mode) {
      case VIEW_MODES.GRID:
        return <AreaQualifierAreaCards areas={areas} />;
      case VIEW_MODES.LIST:
        return <AreaQualifierAreaList areas={areas} />;
      default:
        return <div>Unknown View Mode</div>;
    }
  };
  return <>
        <div style={{
      textAlign: 'right',
      fontSize: '2em'
    }}>
            <button className={generateViewClasses(VIEW_MODES.LIST)} onClick={() => setViewMode(VIEW_MODES.LIST)}>
                <MdList data-sentry-element="MdList" data-sentry-source-file="area-qualifier-region-view.jsx" />
            </button>
            <button className={generateViewClasses(VIEW_MODES.GRID)} onClick={() => setViewMode(VIEW_MODES.GRID)}>
                <MdOutlineGridView data-sentry-element="MdOutlineGridView" data-sentry-source-file="area-qualifier-region-view.jsx" />
            </button>
        </div>
        {renderRegionView(viewMode)}
    </>;
};
export default AreaQualifierRegionView;